import * as Types from "../../../../lib/contentful/__generated/graphql.types";

import {
    ComponentReferenceFields_Car_Fragment,
    ComponentReferenceFields_ContentTag_Fragment,
    ComponentReferenceFields_Driver_Fragment,
    ComponentReferenceFields_ExternalLink_Fragment,
    ComponentReferenceFields_Footer_Fragment,
    ComponentReferenceFields_LanguageSelectorItem_Fragment,
    ComponentReferenceFields_MainNavigation_Fragment,
    ComponentReferenceFields_Microcopy_Fragment,
    ComponentReferenceFields_MicrocopySet_Fragment,
    ComponentReferenceFields_ModalLink_Fragment,
    ComponentReferenceFields_Module916VideoImage_Fragment,
    ComponentReferenceFields_ModuleAccordion_Fragment,
    ComponentReferenceFields_ModuleAudioPlayer_Fragment,
    ComponentReferenceFields_ModuleCarTechSpecs_Fragment,
    ComponentReferenceFields_ModuleCarousel_Fragment,
    ComponentReferenceFields_ModuleCircuit_Fragment,
    ComponentReferenceFields_ModuleDriverList_Fragment,
    ComponentReferenceFields_ModuleGallery_Fragment,
    ComponentReferenceFields_ModuleIframe_Fragment,
    ComponentReferenceFields_ModuleImage_Fragment,
    ComponentReferenceFields_ModuleListenToTheEngine_Fragment,
    ComponentReferenceFields_ModuleLiveTimingTable_Fragment,
    ComponentReferenceFields_ModuleMediaFeature_Fragment,
    ComponentReferenceFields_ModulePageLinkTile_Fragment,
    ComponentReferenceFields_ModuleQuickLinks_Fragment,
    ComponentReferenceFields_ModuleQuote_Fragment,
    ComponentReferenceFields_ModuleRichText_Fragment,
    ComponentReferenceFields_ModuleSideBySide_Fragment,
    ComponentReferenceFields_ModuleSpacer_Fragment,
    ComponentReferenceFields_ModuleSplitLayout_Fragment,
    ComponentReferenceFields_ModuleTable_Fragment,
    ComponentReferenceFields_ModuleTitleAndDescription_Fragment,
    ComponentReferenceFields_ModuleVideo_Fragment,
    ComponentReferenceFields_Navigation_Fragment,
    ComponentReferenceFields_PageArticle_Fragment,
    ComponentReferenceFields_PageBasic_Fragment,
    ComponentReferenceFields_PageCar_Fragment,
    ComponentReferenceFields_PageCategory_Fragment,
    ComponentReferenceFields_PageDriver_Fragment,
    ComponentReferenceFields_PageHomepage_Fragment,
    ComponentReferenceFields_PageRaceEvent_Fragment,
    ComponentReferenceFields_PageRaceSeries_Fragment,
    ComponentReferenceFields_PageSearch_Fragment,
    ComponentReferenceFields_PageTeam_Fragment,
    ComponentReferenceFields_PartAccordionItem_Fragment,
    ComponentReferenceFields_PartCircuitHotspot_Fragment,
    ComponentReferenceFields_PartMainNavigationAccordion_Fragment,
    ComponentReferenceFields_PartMainNavigationItem_Fragment,
    ComponentReferenceFields_Partner_Fragment,
    ComponentReferenceFields_PartnerSet_Fragment,
    ComponentReferenceFields_SeoMetadata_Fragment,
    ComponentReferenceFields_SiteSettings_Fragment,
    ComponentReferenceFields_Team_Fragment,
} from "../../../../lib/contentful/__generated/component-map.contentful.generated";
import {
    ExternalLinkFieldsFragment,
    PageArticleLinkToFieldsFragment,
    PageBasicLinkToFieldsFragment,
    PageCarLinkToFieldsFragment,
    PageCategoryLinkToFieldsFragment,
    PageDriverLinkToFieldsFragment,
    PageHomepageLinkToFieldsFragment,
    PageRaceSeriesLinkToFieldsFragment,
    PageRaceEventLinkToFieldsFragment,
    PageSearchLinkToFieldsFragment,
    PageTeamLinkToFieldsFragment,
} from "../../../../lib/contentful/link-fragments/__generated/link-fragments.contentful.generated";
import {
    MicrocopyFieldsFragment,
    MicrocopySetFieldsFragment,
} from "../../../../lib/contentful/microcopy/__generated/microcopy-sets.contentful.generated";
import { ContentTagFieldsFragment } from "../../../../lib/contentful/content-tag/__generated/content-tag.contentful.generated";
import { ComponentReferenceFieldsFragmentDoc } from "../../../../lib/contentful/__generated/component-map.contentful.generated";
import {
    ExternalLinkFieldsFragmentDoc,
    PageArticleLinkToFieldsFragmentDoc,
    PageBasicLinkToFieldsFragmentDoc,
    PageCarLinkToFieldsFragmentDoc,
    PageCategoryLinkToFieldsFragmentDoc,
    PageDriverLinkToFieldsFragmentDoc,
    PageHomepageLinkToFieldsFragmentDoc,
    PageRaceSeriesLinkToFieldsFragmentDoc,
    PageRaceEventLinkToFieldsFragmentDoc,
    PageSearchLinkToFieldsFragmentDoc,
    PageTeamLinkToFieldsFragmentDoc,
} from "../../../../lib/contentful/link-fragments/__generated/link-fragments.contentful.generated";
import {
    MicrocopyFieldsFragmentDoc,
    MicrocopySetFieldsFragmentDoc,
} from "../../../../lib/contentful/microcopy/__generated/microcopy-sets.contentful.generated";
import { ContentTagFieldsFragmentDoc } from "../../../../lib/contentful/content-tag/__generated/content-tag.contentful.generated";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { customFetcher } from "@/lib/contentful/fetch-config";
export type PartAccordionItemLinkFields_ExternalLink_Fragment = {
    __typename?: "ExternalLink";
} & ExternalLinkFieldsFragment;

export type PartAccordionItemLinkFields_PageArticle_Fragment = {
    __typename?: "PageArticle";
    title?: string | null;
    linkTitle?: string | null;
    slug?: string | null;
} & ComponentReferenceFields_PageArticle_Fragment;

export type PartAccordionItemLinkFields_PageBasic_Fragment = {
    __typename?: "PageBasic";
    title?: string | null;
    linkTitle?: string | null;
    slug?: string | null;
} & ComponentReferenceFields_PageBasic_Fragment;

export type PartAccordionItemLinkFields_PageCar_Fragment = {
    __typename?: "PageCar";
    title?: string | null;
    linkTitle?: string | null;
    slug?: string | null;
} & ComponentReferenceFields_PageCar_Fragment;

export type PartAccordionItemLinkFields_PageCategory_Fragment = {
    __typename?: "PageCategory";
    title?: string | null;
    linkTitle?: string | null;
    mainCategory?: string | null;
} & ComponentReferenceFields_PageCategory_Fragment;

export type PartAccordionItemLinkFields_PageDriver_Fragment = {
    __typename?: "PageDriver";
    title?: string | null;
    linkTitle?: string | null;
    slug?: string | null;
} & ComponentReferenceFields_PageDriver_Fragment;

export type PartAccordionItemLinkFields_PageHomepage_Fragment = {
    __typename?: "PageHomepage";
    title?: string | null;
    linkTitle?: string | null;
} & ComponentReferenceFields_PageHomepage_Fragment;

export type PartAccordionItemLinkFields_PageRaceEvent_Fragment = {
    __typename?: "PageRaceEvent";
    title?: string | null;
    linkTitle?: string | null;
    slug?: string | null;
} & ComponentReferenceFields_PageRaceEvent_Fragment;

export type PartAccordionItemLinkFields_PageRaceSeries_Fragment = {
    __typename?: "PageRaceSeries";
    title?: string | null;
    linkTitle?: string | null;
    slug?: string | null;
} & ComponentReferenceFields_PageRaceSeries_Fragment;

export type PartAccordionItemLinkFields_PageSearch_Fragment = {
    __typename?: "PageSearch";
    title?: string | null;
    linkTitle?: string | null;
} & ComponentReferenceFields_PageSearch_Fragment;

export type PartAccordionItemLinkFields_PageTeam_Fragment = {
    __typename?: "PageTeam";
    title?: string | null;
    linkTitle?: string | null;
    slug?: string | null;
} & ComponentReferenceFields_PageTeam_Fragment;

export type PartAccordionItemLinkFieldsFragment =
    | PartAccordionItemLinkFields_ExternalLink_Fragment
    | PartAccordionItemLinkFields_PageArticle_Fragment
    | PartAccordionItemLinkFields_PageBasic_Fragment
    | PartAccordionItemLinkFields_PageCar_Fragment
    | PartAccordionItemLinkFields_PageCategory_Fragment
    | PartAccordionItemLinkFields_PageDriver_Fragment
    | PartAccordionItemLinkFields_PageHomepage_Fragment
    | PartAccordionItemLinkFields_PageRaceEvent_Fragment
    | PartAccordionItemLinkFields_PageRaceSeries_Fragment
    | PartAccordionItemLinkFields_PageSearch_Fragment
    | PartAccordionItemLinkFields_PageTeam_Fragment;

export type PartAccordionItemFieldsFragment = {
    __typename?: "PartAccordionItem";
    title?: string | null;
    description?: string | null;
    asset?: any | null;
    assetCaption?: string | null;
    link?:
        | ({ __typename?: "ExternalLink" } & PartAccordionItemLinkFields_ExternalLink_Fragment)
        | ({ __typename?: "PageArticle" } & PartAccordionItemLinkFields_PageArticle_Fragment)
        | ({ __typename?: "PageBasic" } & PartAccordionItemLinkFields_PageBasic_Fragment)
        | ({ __typename?: "PageCar" } & PartAccordionItemLinkFields_PageCar_Fragment)
        | ({ __typename?: "PageCategory" } & PartAccordionItemLinkFields_PageCategory_Fragment)
        | ({ __typename?: "PageDriver" } & PartAccordionItemLinkFields_PageDriver_Fragment)
        | ({ __typename?: "PageHomepage" } & PartAccordionItemLinkFields_PageHomepage_Fragment)
        | ({ __typename?: "PageRaceEvent" } & PartAccordionItemLinkFields_PageRaceEvent_Fragment)
        | ({ __typename?: "PageRaceSeries" } & PartAccordionItemLinkFields_PageRaceSeries_Fragment)
        | ({ __typename?: "PageSearch" } & PartAccordionItemLinkFields_PageSearch_Fragment)
        | ({ __typename?: "PageTeam" } & PartAccordionItemLinkFields_PageTeam_Fragment)
        | null;
    table?: {
        __typename?: "PartAccordionItemTable";
        json: any;
        links: {
            __typename?: "PartAccordionItemTableLinks";
            entries: {
                __typename?: "PartAccordionItemTableEntries";
                inline: Array<
                    | ({ __typename?: "Car" } & ComponentReferenceFields_Car_Fragment)
                    | ({ __typename?: "ContentTag" } & ContentTagFieldsFragment &
                          ComponentReferenceFields_ContentTag_Fragment)
                    | ({ __typename?: "Driver" } & ComponentReferenceFields_Driver_Fragment)
                    | ({
                          __typename?: "ExternalLink";
                      } & ComponentReferenceFields_ExternalLink_Fragment)
                    | ({ __typename?: "Footer" } & ComponentReferenceFields_Footer_Fragment)
                    | ({
                          __typename?: "LanguageSelectorItem";
                      } & ComponentReferenceFields_LanguageSelectorItem_Fragment)
                    | ({
                          __typename?: "MainNavigation";
                      } & ComponentReferenceFields_MainNavigation_Fragment)
                    | ({ __typename?: "Microcopy" } & MicrocopyFieldsFragment &
                          ComponentReferenceFields_Microcopy_Fragment)
                    | ({
                          __typename?: "MicrocopySet";
                      } & ComponentReferenceFields_MicrocopySet_Fragment)
                    | ({ __typename?: "ModalLink" } & ComponentReferenceFields_ModalLink_Fragment)
                    | ({
                          __typename?: "Module916VideoImage";
                      } & ComponentReferenceFields_Module916VideoImage_Fragment)
                    | ({
                          __typename?: "ModuleAccordion";
                      } & ComponentReferenceFields_ModuleAccordion_Fragment)
                    | ({
                          __typename?: "ModuleAudioPlayer";
                      } & ComponentReferenceFields_ModuleAudioPlayer_Fragment)
                    | ({
                          __typename?: "ModuleCarTechSpecs";
                      } & ComponentReferenceFields_ModuleCarTechSpecs_Fragment)
                    | ({
                          __typename?: "ModuleCarousel";
                      } & ComponentReferenceFields_ModuleCarousel_Fragment)
                    | ({
                          __typename?: "ModuleCircuit";
                      } & ComponentReferenceFields_ModuleCircuit_Fragment)
                    | ({
                          __typename?: "ModuleDriverList";
                      } & ComponentReferenceFields_ModuleDriverList_Fragment)
                    | ({
                          __typename?: "ModuleGallery";
                      } & ComponentReferenceFields_ModuleGallery_Fragment)
                    | ({
                          __typename?: "ModuleIframe";
                      } & ComponentReferenceFields_ModuleIframe_Fragment)
                    | ({
                          __typename?: "ModuleImage";
                      } & ComponentReferenceFields_ModuleImage_Fragment)
                    | ({
                          __typename?: "ModuleListenToTheEngine";
                      } & ComponentReferenceFields_ModuleListenToTheEngine_Fragment)
                    | ({
                          __typename?: "ModuleLiveTimingTable";
                      } & ComponentReferenceFields_ModuleLiveTimingTable_Fragment)
                    | ({
                          __typename?: "ModuleMediaFeature";
                      } & ComponentReferenceFields_ModuleMediaFeature_Fragment)
                    | ({
                          __typename?: "ModulePageLinkTile";
                      } & ComponentReferenceFields_ModulePageLinkTile_Fragment)
                    | ({
                          __typename?: "ModuleQuickLinks";
                      } & ComponentReferenceFields_ModuleQuickLinks_Fragment)
                    | ({
                          __typename?: "ModuleQuote";
                      } & ComponentReferenceFields_ModuleQuote_Fragment)
                    | ({
                          __typename?: "ModuleRichText";
                      } & ComponentReferenceFields_ModuleRichText_Fragment)
                    | ({
                          __typename?: "ModuleSideBySide";
                      } & ComponentReferenceFields_ModuleSideBySide_Fragment)
                    | ({
                          __typename?: "ModuleSpacer";
                      } & ComponentReferenceFields_ModuleSpacer_Fragment)
                    | ({
                          __typename?: "ModuleSplitLayout";
                      } & ComponentReferenceFields_ModuleSplitLayout_Fragment)
                    | ({
                          __typename?: "ModuleTable";
                      } & ComponentReferenceFields_ModuleTable_Fragment)
                    | ({
                          __typename?: "ModuleTitleAndDescription";
                      } & ComponentReferenceFields_ModuleTitleAndDescription_Fragment)
                    | ({
                          __typename?: "ModuleVideo";
                      } & ComponentReferenceFields_ModuleVideo_Fragment)
                    | ({ __typename?: "Navigation" } & ComponentReferenceFields_Navigation_Fragment)
                    | ({
                          __typename?: "PageArticle";
                      } & ComponentReferenceFields_PageArticle_Fragment)
                    | ({ __typename?: "PageBasic" } & ComponentReferenceFields_PageBasic_Fragment)
                    | ({ __typename?: "PageCar" } & ComponentReferenceFields_PageCar_Fragment)
                    | ({
                          __typename?: "PageCategory";
                      } & ComponentReferenceFields_PageCategory_Fragment)
                    | ({ __typename?: "PageDriver" } & ComponentReferenceFields_PageDriver_Fragment)
                    | ({
                          __typename?: "PageHomepage";
                      } & ComponentReferenceFields_PageHomepage_Fragment)
                    | ({
                          __typename?: "PageRaceEvent";
                      } & ComponentReferenceFields_PageRaceEvent_Fragment)
                    | ({
                          __typename?: "PageRaceSeries";
                      } & ComponentReferenceFields_PageRaceSeries_Fragment)
                    | ({ __typename?: "PageSearch" } & ComponentReferenceFields_PageSearch_Fragment)
                    | ({ __typename?: "PageTeam" } & ComponentReferenceFields_PageTeam_Fragment)
                    | ({
                          __typename?: "PartAccordionItem";
                      } & ComponentReferenceFields_PartAccordionItem_Fragment)
                    | ({
                          __typename?: "PartCircuitHotspot";
                      } & ComponentReferenceFields_PartCircuitHotspot_Fragment)
                    | ({
                          __typename?: "PartMainNavigationAccordion";
                      } & ComponentReferenceFields_PartMainNavigationAccordion_Fragment)
                    | ({
                          __typename?: "PartMainNavigationItem";
                      } & ComponentReferenceFields_PartMainNavigationItem_Fragment)
                    | ({ __typename?: "Partner" } & ComponentReferenceFields_Partner_Fragment)
                    | ({ __typename?: "PartnerSet" } & ComponentReferenceFields_PartnerSet_Fragment)
                    | ({
                          __typename?: "SeoMetadata";
                      } & ComponentReferenceFields_SeoMetadata_Fragment)
                    | ({
                          __typename?: "SiteSettings";
                      } & ComponentReferenceFields_SiteSettings_Fragment)
                    | ({ __typename?: "Team" } & ComponentReferenceFields_Team_Fragment)
                    | null
                >;
                hyperlink: Array<
                    | { __typename?: "Car" }
                    | { __typename?: "ContentTag" }
                    | { __typename?: "Driver" }
                    | { __typename?: "ExternalLink" }
                    | { __typename?: "Footer" }
                    | { __typename?: "LanguageSelectorItem" }
                    | { __typename?: "MainNavigation" }
                    | { __typename?: "Microcopy" }
                    | { __typename?: "MicrocopySet" }
                    | { __typename?: "ModalLink" }
                    | { __typename?: "Module916VideoImage" }
                    | { __typename?: "ModuleAccordion" }
                    | { __typename?: "ModuleAudioPlayer" }
                    | { __typename?: "ModuleCarTechSpecs" }
                    | { __typename?: "ModuleCarousel" }
                    | { __typename?: "ModuleCircuit" }
                    | { __typename?: "ModuleDriverList" }
                    | { __typename?: "ModuleGallery" }
                    | { __typename?: "ModuleIframe" }
                    | { __typename?: "ModuleImage" }
                    | { __typename?: "ModuleListenToTheEngine" }
                    | { __typename?: "ModuleLiveTimingTable" }
                    | { __typename?: "ModuleMediaFeature" }
                    | { __typename?: "ModulePageLinkTile" }
                    | { __typename?: "ModuleQuickLinks" }
                    | { __typename?: "ModuleQuote" }
                    | { __typename?: "ModuleRichText" }
                    | { __typename?: "ModuleSideBySide" }
                    | { __typename?: "ModuleSpacer" }
                    | { __typename?: "ModuleSplitLayout" }
                    | { __typename?: "ModuleTable" }
                    | { __typename?: "ModuleTitleAndDescription" }
                    | { __typename?: "ModuleVideo" }
                    | { __typename?: "Navigation" }
                    | ({
                          __typename?: "PageArticle";
                          slug?: string | null;
                          sys: { __typename?: "Sys"; locale?: string | null };
                      } & ComponentReferenceFields_PageArticle_Fragment)
                    | ({
                          __typename?: "PageBasic";
                          slug?: string | null;
                          sys: { __typename?: "Sys"; locale?: string | null };
                      } & ComponentReferenceFields_PageBasic_Fragment)
                    | ({
                          __typename?: "PageCar";
                          slug?: string | null;
                          sys: { __typename?: "Sys"; locale?: string | null };
                      } & ComponentReferenceFields_PageCar_Fragment)
                    | ({
                          __typename?: "PageCategory";
                          mainCategory?: string | null;
                          sys: { __typename?: "Sys"; locale?: string | null };
                      } & ComponentReferenceFields_PageCategory_Fragment)
                    | ({
                          __typename?: "PageDriver";
                          slug?: string | null;
                          sys: { __typename?: "Sys"; locale?: string | null };
                      } & ComponentReferenceFields_PageDriver_Fragment)
                    | ({
                          __typename?: "PageHomepage";
                          sys: { __typename?: "Sys"; locale?: string | null };
                      } & ComponentReferenceFields_PageHomepage_Fragment)
                    | ({
                          __typename?: "PageRaceEvent";
                          slug?: string | null;
                          sys: { __typename?: "Sys"; locale?: string | null };
                      } & ComponentReferenceFields_PageRaceEvent_Fragment)
                    | ({
                          __typename?: "PageRaceSeries";
                          slug?: string | null;
                          sys: { __typename?: "Sys"; locale?: string | null };
                      } & ComponentReferenceFields_PageRaceSeries_Fragment)
                    | ({
                          __typename?: "PageSearch";
                          sys: { __typename?: "Sys"; locale?: string | null };
                      } & ComponentReferenceFields_PageSearch_Fragment)
                    | ({
                          __typename?: "PageTeam";
                          slug?: string | null;
                          sys: { __typename?: "Sys"; locale?: string | null };
                      } & ComponentReferenceFields_PageTeam_Fragment)
                    | { __typename?: "PartAccordionItem" }
                    | { __typename?: "PartCircuitHotspot" }
                    | { __typename?: "PartMainNavigationAccordion" }
                    | { __typename?: "PartMainNavigationItem" }
                    | { __typename?: "Partner" }
                    | { __typename?: "PartnerSet" }
                    | { __typename?: "SeoMetadata" }
                    | { __typename?: "SiteSettings" }
                    | { __typename?: "Team" }
                    | null
                >;
            };
        };
    } | null;
} & ComponentReferenceFields_PartAccordionItem_Fragment;

export type ModuleAccordionFieldsFragment = {
    __typename?: "ModuleAccordion";
    title?: string | null;
    subtitle?: string | null;
    theme?: string | null;
    isTitleLeftAligned?: boolean | null;
    partAccordionItemsCollection?: {
        __typename?: "ModuleAccordionPartAccordionItemsCollection";
        items: Array<
            ({ __typename?: "PartAccordionItem" } & PartAccordionItemFieldsFragment) | null
        >;
    } | null;
} & ComponentReferenceFields_ModuleAccordion_Fragment;

export type ModuleAccordionQueryVariables = Types.Exact<{
    locale: Types.Scalars["String"]["input"];
    preview?: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
    id: Types.Scalars["String"]["input"];
}>;

export type ModuleAccordionQuery = {
    __typename?: "Query";
    accordion?: ({ __typename?: "ModuleAccordion" } & ModuleAccordionFieldsFragment) | null;
};

export const PartAccordionItemLinkFieldsFragmentDoc = `
    fragment PartAccordionItemLinkFields on PartAccordionItemLink {
  ... on PageArticle {
    ...ComponentReferenceFields
    title
    linkTitle
    slug
  }
  ... on PageBasic {
    ...ComponentReferenceFields
    title
    linkTitle
    slug
  }
  ... on PageCar {
    ...ComponentReferenceFields
    title
    linkTitle
    slug
  }
  ... on PageCategory {
    ...ComponentReferenceFields
    title
    linkTitle
    mainCategory
  }
  ... on PageDriver {
    ...ComponentReferenceFields
    title
    linkTitle
    slug
  }
  ... on PageHomepage {
    ...ComponentReferenceFields
    title
    linkTitle
  }
  ... on PageRaceSeries {
    ...ComponentReferenceFields
    title
    linkTitle
    slug
  }
  ... on PageRaceEvent {
    ...ComponentReferenceFields
    title
    linkTitle
    slug
  }
  ... on PageSearch {
    ...ComponentReferenceFields
    title
    linkTitle
  }
  ... on PageTeam {
    ...ComponentReferenceFields
    title
    linkTitle
    slug
  }
  ... on ExternalLink {
    ...ExternalLinkFields
  }
}
    `;
export const PartAccordionItemFieldsFragmentDoc = `
    fragment PartAccordionItemFields on PartAccordionItem {
  ...ComponentReferenceFields
  title
  description
  asset
  assetCaption
  link {
    ...PartAccordionItemLinkFields
  }
  table {
    json
    links {
      entries {
        inline {
          ...ComponentReferenceFields
          ... on Microcopy {
            ...MicrocopyFields
          }
          ... on ContentTag {
            ...ContentTagFields
          }
        }
        hyperlink {
          ... on PageHomepage {
            ...ComponentReferenceFields
            sys {
              locale
            }
          }
          ... on PageSearch {
            ...ComponentReferenceFields
            sys {
              locale
            }
          }
          ... on PageArticle {
            ...ComponentReferenceFields
            sys {
              locale
            }
            slug
          }
          ... on PageBasic {
            ...ComponentReferenceFields
            sys {
              locale
            }
            slug
          }
          ... on PageCar {
            ...ComponentReferenceFields
            sys {
              locale
            }
            slug
          }
          ... on PageCategory {
            ...ComponentReferenceFields
            sys {
              locale
            }
            mainCategory
          }
          ... on PageDriver {
            ...ComponentReferenceFields
            sys {
              locale
            }
            slug
          }
          ... on PageRaceSeries {
            ...ComponentReferenceFields
            sys {
              locale
            }
            slug
          }
          ... on PageRaceEvent {
            ...ComponentReferenceFields
            sys {
              locale
            }
            slug
          }
          ... on PageTeam {
            ...ComponentReferenceFields
            sys {
              locale
            }
            slug
          }
        }
      }
    }
  }
}
    `;
export const ModuleAccordionFieldsFragmentDoc = `
    fragment ModuleAccordionFields on ModuleAccordion {
  ...ComponentReferenceFields
  title
  subtitle
  theme
  isTitleLeftAligned
  partAccordionItemsCollection(limit: 10) {
    items {
      ...PartAccordionItemFields
    }
  }
}
    `;
export const ModuleAccordionDocument = `
    query ModuleAccordion($locale: String!, $preview: Boolean, $id: String!) {
  accordion: moduleAccordion(id: $id, locale: $locale, preview: $preview) {
    ...ModuleAccordionFields
  }
}
    ${ModuleAccordionFieldsFragmentDoc}
${ComponentReferenceFieldsFragmentDoc}
${PartAccordionItemFieldsFragmentDoc}
${PartAccordionItemLinkFieldsFragmentDoc}
${ExternalLinkFieldsFragmentDoc}
${MicrocopyFieldsFragmentDoc}
${ContentTagFieldsFragmentDoc}`;

export const useModuleAccordionQuery = <TData = ModuleAccordionQuery, TError = unknown>(
    variables: ModuleAccordionQueryVariables,
    options?: Omit<UseQueryOptions<ModuleAccordionQuery, TError, TData>, "queryKey"> & {
        queryKey?: UseQueryOptions<ModuleAccordionQuery, TError, TData>["queryKey"];
    }
) => {
    return useQuery<ModuleAccordionQuery, TError, TData>({
        queryKey: ["ModuleAccordion", variables],
        queryFn: customFetcher<ModuleAccordionQuery, ModuleAccordionQueryVariables>(
            ModuleAccordionDocument,
            variables
        ),
        ...options,
    });
};

useModuleAccordionQuery.getKey = (variables: ModuleAccordionQueryVariables) => [
    "ModuleAccordion",
    variables,
];

useModuleAccordionQuery.fetcher = (
    variables: ModuleAccordionQueryVariables,
    options?: RequestInit["headers"]
) =>
    customFetcher<ModuleAccordionQuery, ModuleAccordionQueryVariables>(
        ModuleAccordionDocument,
        variables,
        options
    );
